import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { LanguageProvider } from "./lib/i18n";
import { ProtectedRoute } from "./components/ProtectedRoute";
import AuthCallback from "./pages/AuthCallback";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import ClientHome from "./pages/ClientHome";
import NewRequest from "./pages/NewRequest";
import ClientOrders from "./pages/ClientOrders";
import OrderDetail from "./pages/OrderDetail";
import TechDashboard from "./pages/TechDashboard";
import AdminDashboard from "./pages/AdminDashboard";
import AdminOrderDetail from "./pages/AdminOrderDetail";
import AlertsHistory from "./pages/AlertsHistory";
import { PaymentSuccess, PaymentCancel } from "./pages/PaymentResult";
// B2B public site
import B2BHome from "./pages/b2b/B2BHome";
import B2BPlans from "./pages/b2b/B2BPlans";
import B2BWhatWeCheck from "./pages/b2b/B2BWhatWeCheck";
import B2BPropertyManagers from "./pages/b2b/B2BPropertyManagers";
import B2BContact from "./pages/b2b/B2BContact";
import B2BSelector from "./pages/b2b/B2BSelector";
import B2BPrivacy from "./pages/b2b/B2BPrivacy";
// B2B admin lead management
import AdminLeads from "./pages/admin/AdminLeads";
import AdminLeadDetail from "./pages/admin/AdminLeadDetail";
import AdminB2BSettings from "./pages/admin/AdminB2BSettings";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      {/* ---- Public B2B marketing site ---- */}
      <Route path="/" element={<B2BHome />} />
      <Route path="/piani" element={<B2BPlans />} />
      <Route path="/cosa-controlliamo" element={<B2BWhatWeCheck />} />
      <Route path="/property-manager" element={<B2BPropertyManagers />} />
      <Route path="/contatti" element={<B2BContact />} />
      <Route path="/scegli-piano" element={<B2BSelector />} />
      <Route path="/privacy" element={<B2BPrivacy />} />

      {/* ---- Auth ---- */}
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />

      {/* ---- On-demand client app (relocated under /area-clienti) ---- */}
      <Route path="/area-clienti" element={<ProtectedRoute roles={["cliente"]}><ClientHome /></ProtectedRoute>} />
      <Route path="/area-clienti/richiedi" element={<ProtectedRoute roles={["cliente"]}><NewRequest /></ProtectedRoute>} />
      <Route path="/area-clienti/ordini" element={<ProtectedRoute roles={["cliente"]}><ClientOrders /></ProtectedRoute>} />
      <Route path="/ordine/:id" element={<ProtectedRoute roles={["cliente", "tecnico"]}><OrderDetail /></ProtectedRoute>} />

      {/* ---- Technician ---- */}
      <Route path="/tecnico" element={<ProtectedRoute roles={["tecnico"]}><TechDashboard /></ProtectedRoute>} />

      {/* ---- Admin / operations center ---- */}
      <Route path="/centrale" element={<ProtectedRoute roles={["admin"]}><AdminDashboard /></ProtectedRoute>} />
      <Route path="/centrale/ordine/:id" element={<ProtectedRoute roles={["admin"]}><AdminOrderDetail /></ProtectedRoute>} />
      <Route path="/centrale/avvisi" element={<ProtectedRoute roles={["admin"]}><AlertsHistory /></ProtectedRoute>} />
      <Route path="/centrale/lead" element={<ProtectedRoute roles={["admin"]}><AdminLeads /></ProtectedRoute>} />
      <Route path="/centrale/lead/:id" element={<ProtectedRoute roles={["admin"]}><AdminLeadDetail /></ProtectedRoute>} />
      <Route path="/centrale/b2b" element={<ProtectedRoute roles={["admin"]}><AdminB2BSettings /></ProtectedRoute>} />
    </Routes>
  );
}

export default function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-center" richColors />
        </AuthProvider>
      </BrowserRouter>
    </LanguageProvider>
  );
}
